export default {
  CUSTOMER_TYPE: {
    AIRPORT: 'airport',
    AIRPLANE: 'airplane',
  },

  ABILITY: {
    DEFAULT: 'default',
    SUPER_ADMIN: 'super_admin',
    USER_MANAGEMENT: 'user_management',
    CUSTOMER_MANAGEMENT: 'customer_management',
    BIGQUERY_MANAGEMENT: 'bigquery_table_management',
    BIGQUERY_SELECTOR: 'bigquery_table_selection',
    LOG_VERSION_MANAGEMENT: 'logs_version_management',
    ANALYTICS: 'analytics',
    CUSTOMER: 'customer',
    INTERN: 'intern',
    CONFIGURATOR: 'configurator',
    DEVELOPER: 'developer',
    EXPORT: 'export_ui',
    EXPORT_SEARCH: 'export_search_data',
    DASHBOARD_MANAGEMENT: 'dashboard_management',
    VIDEO_ASSETS: 'video_assets',
    HIDDEN_VIEW: 'hidden_view',
    SERVICE_TAIL_NUMBERS_REPORT: 'service_tail_numbers_report',
    SERVICE_LOGS_TRACKING_30_M: 'service_logs_tracking_30_m',
    SERVICE_LOGS_TRACKING_1_H: 'service_logs_tracking_1_h',
    SERVICE_LOGS_TRACKING_1_D: 'service_logs_tracking_1_d',
    SELECT_REQUEST_METHOD: 'select_request_method',
  },
  DATA_LISTS: {
    DASHBOARD_ELEMENTS: {
      type: 'dashboard_elements',
      path: 'dashboard/getCompositeCustomerData',
      method: 'post',
      withOverlay: true,
    },
    DASHBOARD_ELEMENTS_LAYOUTS: {
      type: 'dashboard_elements_layouts',
      path: 'dashboard/getDashboardConstructionElementsLayouts',
      method: 'get',
      withOverlay: true,
    },
    DASHBOARD_ELEMENTS_METRICS: {
      type: 'dashboard_elements_metrics',
      path: 'dashboard/getDashboardConstructionElementsMetrics',
      method: 'get',
      withOverlay: true,
    },
    DASHBOARD_ELEMENTS_CLASSES: {
      type: 'dashboard_elements_classes',
      path: 'dashboard/getDashboardConstructionElementsClasses',
      method: 'get',
      withOverlay: true,
    },
    DASHBOARD_ELEMENTS_STRUCTURE: {
      type: 'dashboard_elements_structure',
      path: 'dashboard/getDashboardConstructionElementsStructure',
      method: 'get',
      withOverlay: true,
    },
  },
};
